<template>
    <keep-alive>
        <div class="modal-mask">
            <div class="modal-wrapper">
                <div class="modal_size md_size">
                    <a href="JavaScript:" class="ui_close" type="button" @click="$emit('close')"><span class="sr_only">popup close</span></a>
                    <dl class="modal_content">
                        <dt class="ellipsis">
                            <i>Select Product Category</i>
                        </dt>
                        <dd>
                            <div class="Select_wrap">
                                <ul class="txt_sel">
                                    <li class="tit">{{$t('FIELD.FAQ.CORP')}}</li>
                                    <li data-input-type="select" class="sel">
                                        <select class="slt_white w35" id="prod1" v-model="prodCate1" @change="changeProdCd(1)">
                                            <option value='' selected>{{$t('FIELD.GLOBAL.OPTION.DETAIL.NAME')}}</option>
                                            <option v-for="code in prodCategories1" :key="code.code" :value="code.code">{{code.codeDesc}}</option>
                                        </select>
                                        <select class="slt_white w30" id="prod2" v-model="prodCate2" @change="changeProdCd(2)">
                                            <option value='' selected>{{$t('FIELD.GLOBAL.OPTION.DETAIL.NAME')}}</option>
                                            <option v-for="code in prodCategories2" :key="code.code" :value="code.code">{{code.codeDesc}}</option>
                                        </select>
                                        <select class="slt_white w30" id="prod3" v-model="prodCate3">
                                            <option value='' selected>{{$t('FIELD.GLOBAL.OPTION.DETAIL.NAME')}}</option>
                                            <option v-for="code in prodCategories3" :key="code.code" :value="code.code">{{code.codeDesc}}</option>
                                        </select>
                                    </li>
                                </ul>
                            </div>
                            <div class="pop_sel_multiple">
                                <select multiple v-model="cateSel">
                                    <option v-for="code in addedCategories" :key="code.PROD_CD" :value="code.PROD_CD">{{code.PROD_NM}}</option>
                                </select>
                            </div>
                            <div class="btn_wrap pt-10">
                                <div class="btn_right">
                                    <a href="JavaScript:" class="btn_sm_white" title="" @click="addProds()">{{$t('BUTTON.GLOBAL.ADD')}}</a>
                                    <a href="JavaScript:" class="btn_sm_white" title="" @click="delProds()">{{$t('BUTTON.GLOBAL.DELETE')}}</a>
                                </div>
                            </div>
                            <div class="btn_modal_wrap topLine">
                                <div class="btn_right">
                                    <a href="JavaScript:" class="btn_white" title="" @click="$emit('close')">{{$t('BUTTON.GLOBAL.CANCEL')}}</a>
                                    <a href="JavaScript:" class="btn_blue" title="" @click="saveCategory()">{{$t('BUTTON.GLOBAL.SAVE')}}</a>
                                </div>
                            </div>
                        </dd>
                    </dl>
                </div>
            </div>
        </div>
    </keep-alive>
</template>
<script>
import Vue from 'vue';
import qs from 'query-string';
import axios from 'axios';
import { SDLUtil } from '@/utils';
import { EventBus } from '@/utils/EventBus';

// Toast Grid Custom Renderer
export default {
    name: 'selectProductCategory',
    components: {
    },
    props: {
        isConfirm: { type: Boolean, default: true },
        rtnFunc: { type: Function }
    },
    data() {
        return {
            prodCate1: '',
            prodCate2: '',
            prodCate3: '',
            prodCate1Nm: '',
            prodCate2Nm: '',
            prodCate3Nm: '',
            prodCategories1: [],
            prodCategories2: [],
            prodCategories3: [],
            cateSel: [],
            addedCategories: [],
            selectList: [],
            options: {
                scrollY: false,
                scrollX: false,
                minBodyHeight: 80,
                bodyHeight: 400,
                // rowHeaders: ['checkbox'],
            }
        };
    },
    methods: {
        loadProducts(mode, param) {
            param.depth     = mode;
            console.log('param ==> ', param);
            return axios.post(
                `${SDLUtil.API_URL}/basis/admin/system/userRole/productCategories.skp`,
                qs.stringify(param),
                {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    params: { searchInfo: 'set' },
                },
            ).then(resp => {
                console.log('resp ==> ', resp);
                if (mode == 1) { // product 1depth
                    this.prodCategories1 = resp.data;
                    this.prodCate1       = resp.data[0].code;
                    param.parentCode     = this.prodCate1;
                    this.loadProducts(2, param);
                } else if (mode == 2) { // product 2depth
                    this.prodCategories2 = resp.data;
                    if (resp.data.length == 0) {
                        this.prodCate2   = '';
                        this.prodCate3   = '';
                    } else {
                        this.prodCate2   = resp.data[0].code;
                        param.parentCode = this.prodCate2;
                        this.loadProducts(3, param);
                    }
                } else if (mode == 3) { // product 3depth
                    this.prodCategories3 = resp.data;
                    if (resp.data.length == 0)  this.prodCate3 = '';
                    else         this.prodCate3 = resp.data[0].code;
                }
            }).catch(err => {
                console.log('Error occured : ', err);
            });
        },
        changeProdCd(mode) {
            if (mode == 1) { // product code - 1Depth
                if (this.prodCate1 == '') {
                    this.prodCategories2 = [];
                    this.prodCate2 = '';
                } else {
                    let param = {codeCategoryId : 'PRODUCT_GROUP', parentCode: this.prodCate1};
                    this.loadProducts(2, param);
                }
            } else if (mode == 2) { // product code - 2Depth
                if (this.prodCate2 == '') {
                    this.prodCategories3 = [];
                    this.prodCate3 = '';
                } else {
                    let param = {codeCategoryId : 'PRODUCT_GROUP', parentCode: this.prodCate2};
                    this.loadProducts(3, param);
                }
            }
        },
        appendValidation(itemCd) {
            let bRes = true;
            let valids = [this.prodCate1, this.prodCate2, this.prodCate3];
            let titles = ['Subsidiary 1-depth', 'Subsidiary 2-depth', 'Subsidiary 3-depth'];
            $.each(valids, function(idx, elm) {
                if (!elm) {
                    bRes = false;
                    SDLUtil.alert('Empty value of [' + titles[idx] + ']');
                    return;
                }
            });

            // 동일한 코드가 있으면 안된다.
            this.addedCategories.forEach(elm => {
                if (elm.PROD_CD == itemCd) {
                    bRes = false;
                    SDLUtil.alert('MESSAGE.ADDED.ALREADY');
                    return;
                }
            });

            return bRes;            
        },
        // multi-select에 Product 추가
        addProds() {
            let prd1 = $('#prod1 option:selected').text();
            let prd2 = $('#prod2 option:selected').text();
            let prd3 = $('#prod3 option:selected').text();
            let itemCd = this.prodCate1 + '^' + this.prodCate2 + '^' + this.prodCate3;
            let itemNm = prd1 + ' > ' + prd2 + ' > ' + prd3;
            let items = {PROD_CD: itemCd, PROD_NM: itemNm};
            if (!this.appendValidation(itemCd)) { return; } 
            this.addedCategories.push(items);
        },
        // multi-select에서 Product 제거
        delProds() {
            if (this.cateSel.length < 1) {
                SDLUtil.alert('FIELD.GLOBAL.OPTION.DETAIL.NAME');
                return;
            }
            let newList = [];
            this.addedCategories.forEach(elm => {
                let prodCd = elm.PROD_CD;
                let exist = this.cateSel.indexOf(prodCd);
                if (exist < 0) newList.push(elm);
            });
            this.addedCategories = newList;
            this.cateSel = [];
        },
        saveCategory() {
            if (this.addedCategories.length == 0) {
                SDLUtil.alert('FIELD.GLOBAL.NODATA');
                return;
            }

            let saveCateList = [];
            this.addedCategories.forEach(elm => {
                console.log('elm ==> ', elm);
                saveCateList.push(elm);
            });

            if (this.isConfirm) { // 물어보고 실행
                SDLUtil.confirm({
                    msg: 'MESSAGE.HME.SUBMIT.CONFIRM',
                    title: 'BUTTON.GLOBAL.SAVE',
                    onOkEvt: () => {
                        this.rtnFunc(saveCateList);
                        this.$emit('close');
                    },
                });
            } else { // 물어보지 않고 바로 실행
                this.rtnFunc(saveCateList);
                this.$emit('close');
            }
        }
    },
    mounted() {
        this.loadProducts(1, { depth : 1 });
    },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/skpComponents/view/admin/system/userRole/CategoryAddPopup.vue